import Repository from "./Repository";

const ADD_ENTRY = "addcatalogue";
const DELETE_ENTRY = "delete";
const UPDATE_ENTRY = "update";
const GET_ENTRY = "getcatalogue";
const GET_MANY ="getSingle"

export default {
  addCollection(payload) {
    return Repository.post(transformRoute(ADD_ENTRY), payload);
  },
  editCategory(payload) {
    return Repository.post(transformRoute(UPDATE_ENTRY), payload);
  },
  deleteCollection(payload) {
    return Repository.post(transformRoute(DELETE_ENTRY), payload);
  },
  getCategories(payload) {
    return Repository.post(transformRoute(GET_ENTRY), payload);
  },
  getMany(payload) {
    return Repository.post(transformRoute(GET_MANY), payload);
  },
};

const transformRoute = (route) => {
  return `/catalogue/${route}`;
};
